import { AbstractControl } from '@angular/forms';

// Taken from https://stackoverflow.com/a/5717133 with some updates
const URL_PATTERN = new RegExp('^https?:\\/\\/' + // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
  '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

export function urlValidator(control: AbstractControl): { [key: string]: any } | null {
  if (!control.value) {
    return null;
  }

  if (typeof control.value === 'string' && URL_PATTERN.test(control.value)) {
    return null;
  }

  return {url: true};
}
